export default {
  chat: () => {
    window.LC_API.open_chat_window()
  },
}